import { Geografi, Parti } from '../../../domain'
import { OSLO_FYLKE } from '../geografi'
import { flatSingle } from '../../../../lib/array'

import Fuse from 'fuse.js'

async function initializeFuse(grunndata, locale) {
  const { default: Fuse } = await import('fuse.js' /* webpackChunkName: "@fuse.js" */)

  return new Fuse<Geografi | Parti>(grunndata, {
    keys: [
      { name: 'navn.' + locale, weight: 1 },
      { name: 'navn.nb', weight: 1 },
      { name: 'sokbartKortNavn', weight: 1 }
    ],
    threshold: 0.25,
    maxPatternLength: 56,
    includeScore: true
  })
}

export class GrunndataSearch {
  fuse: Promise<Fuse<Geografi | Parti>>

  constructor(geografi: Geografi[], partier: Parti[], locale: string) {
    const filtrertGeografi = geografi.filter(geo => geo.key !== OSLO_FYLKE && geo.type !== 'Krets')

    /* 
    Bygdelister som Dovrelista har kortnavn DOVR og scorer dermed bedre enn kommunen Dovre.
    Fjerner kortnavn fra lokale lister da vi antar at brukerene ikke vil søke etter kortnavn på disse listene. 
    */
    const partiliste = partier.map(parti => ({
      ...parti,
      sokbartKortNavn: parti.kategori < 3 ? parti.kortNavn : undefined
    }))

    const tidligereSteder = flatSingle(
      filtrertGeografi
        .filter(geo => geo.sammenslattAv && geo.sammenslattAv.length)
        .map((geo: Geografi) =>
          geo
            .sammenslattAv!.filter(tidligereNavn => tidligereNavn.nb !== geo.navn.nb)
            .map(tidligereNavn => ({ ...geo, navn: tidligereNavn, nyttNavn: geo.navn } as Geografi))
        )
    )

    const grunndata = [...filtrertGeografi, ...tidligereSteder, ...partiliste]
    this.fuse = initializeFuse(grunndata, locale)
  }

  async search(value): Promise<Array<Geografi | Parti>> {
    const fuse = await this.fuse
    return (
      fuse
        .search(value)
        /*
         * Straffer tidligere kommuner slik at de ikke kommer før i søket enn de nye:
         * */
        .map(({ score, item }: any) => {
          if (item.nyttNavn && item.nyttNavn.nb === 'Troms og Finnmark') {
            return { score: score + 0.1, item }
          }
          return { score, item }
        })
        .sort((a, b) => a.score - b.score)
        .map(({ item }) => item)
    )
  }
}
